<div class="krypton-tab-handler" tabindex="0" @focus="onFocus"></div>